import { FC } from 'react';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import { useMasterDataSettingListingPage } from './master-data-setting-listing-page.hook';
import { MasterDataSettingList } from './components/master-data-setting-list.component';

type MasterDataSettingListingPageProps = ParamsProps;

export const MasterDataSettingListingPage: FC<MasterDataSettingListingPageProps> = ({
  initialParams,
  onChangeQueryParams,
}) => {
  const { masterDataSettingList, isLoading, refreshData } = useMasterDataSettingListingPage({
    initialParams,
    onChangeQueryParams,
  });

  return (
    <>
      <MasterDataSettingList
        isLoading={isLoading}
        masterDataSettingList={masterDataSettingList}
        onRefresh={refreshData}
      />
    </>
  );
};
